<template>
  <a-input
    v-bind="$attrs"
    :value="value"
    :name="fieldName"
    autocomplete="off"
    :type="inputType"
    :class="maskClass"
    @change="handleValue"
    @blur="handleBlur"
    @pressEnter="handlePressEnter"
  >
    <a-icon
      slot="suffix"
      :type="visible ? 'eye' : 'eye-invisible'"
      class="pwd-toggle"
      @click="toggle"
    />
  </a-input>
</template>

<script>
/**
 * 密码输入框（不触发浏览器「保存/更新密码」提示）
 * 原理：浏览器仅在存在 type="password" 时才弹出密码管理器气泡，
 * 因此这里使用 type="text" + CSS(-webkit-text-security) 显示为圆点。
 * 不支持该 CSS 的浏览器（如 Firefox）自动回退为原生 password 类型。
 */
export default {
  name: 'SecurityPasswordInput',
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      visible: false,
      // 随机 name：避免浏览器按字段名关联历史输入值/自动填充下拉
      fieldName: 'pwd_' + Math.random().toString(36).slice(2, 10),
      textSecuritySupported: typeof CSS !== 'undefined' &&
        typeof CSS.supports === 'function' &&
        CSS.supports('-webkit-text-security', 'disc')
    }
  },
  computed: {
    inputType () {
      if (this.textSecuritySupported) return 'text'
      return this.visible ? 'text' : 'password'
    },
    maskClass () {
      return (this.textSecuritySupported && !this.visible) ? 'salary-pwd-mask' : ''
    }
  },
  methods: {
    toggle () {
      this.visible = !this.visible
    },
    handleValue (e) {
      const val = e && e.target && typeof e.target.value !== 'undefined' ? e.target.value : e
      this.$emit('input', val)
      this.$emit('change', e)
    },
    handleBlur (e) {
      this.$emit('blur', e)
    },
    handlePressEnter (e) {
      this.$emit('pressEnter', e)
    }
  }
}
</script>

<style>
.salary-pwd-mask .ant-input {
  -webkit-text-security: disc;
}

.salary-pwd-mask .ant-input::placeholder {
  -webkit-text-security: none;
}

.pwd-toggle {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/salary/security/PasswordInput.vue